import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'

/**
 * pt-BR é a FONTE DA VERDADE; en espelha. CI compara as árvores de chave.
 *
 * Namespaces por módulo (espelham as tags do OpenAPI) carregam sob demanda via
 * resourcesToBackend — os de módulo entram quando a rota que os usa monta.
 * Só os 3 críticos vão no boot; o resto seria peso morto no chunk inicial.
 */
await i18n
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      (lng: string, ns: string) => import(`./locales/${lng}/${ns}.json`) as Promise<unknown>,
    ),
  )
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'en'],
    defaultNS: 'common',
    ns: ['common', 'errors', 'validation'],
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
    // O React já escapa. Ligar aqui geraria escape duplo (&amp;amp;).
    interpolation: { escapeValue: false },
    returnNull: false,
    // Sem isto, uma tradução vazia renderiza VAZIO em vez de cair no fallback —
    // o modo de falha silencioso mais fácil de não perceber num app bilíngue.
    returnEmptyString: false,
  })

export default i18n
